
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexesGrid extends SiteEntityGrid<IndexesRow, any> {
        protected getColumnsKey() { return IndexesColumns.columnsKey; }
        protected getDialogType() { return IndexesDialog; }
        protected getIdProperty() { return IndexesRow.idProperty; }
        protected getInsertPermission() { return IndexesRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexesRow.localTextPrefix; }
        protected getService() { return IndexesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}